import { render, staticRenderFns } from "./VideoPlayerVimeoVideoOld.vue?vue&type=template&id=37b990f1"
import script from "./VideoPlayerVimeoVideoOld.vue?vue&type=script&lang=js"
export * from "./VideoPlayerVimeoVideoOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports